var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.854,
    height: 25.854,
    viewBox: "0 0 25.854 25.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancelled",
    transform: "translate(0 -0.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stopped",
    d: "M19.05,21.589,4.763,7.3a10.425,10.425,0,0,0-2.041,6.123A10.235,10.235,0,0,0,12.927,23.63a10.068,10.068,0,0,0,6.123-2.041M6.8,5.261,21.091,19.548a10.068,10.068,0,0,0,2.041-6.123A10.235,10.235,0,0,0,12.927,3.219,10.425,10.425,0,0,0,6.8,5.261M12.927.5A12.927,12.927,0,1,1,0,13.425,12.9,12.9,0,0,1,12.927.5",
    transform: "translate(0 0)",
    fill: "#e21313",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.5b78f419512040d6850d6c39284643f1.svg";
export { ForwardRef as ReactComponent };